export const LOGIN = '/login';
export const LOGOUT = 'logout';
export const PAGE404 = '*';

// dashboard page
export const DASHBOARD = '/';
export const EMPLOYEE = 'employee';
export const EMPLOYEES = 'employees';
export const ALL_EMPLOYEES = 'all-employees';
export const CONTRACT = 'contract';
export const CALENDAR = 'calendar';
export const STATISTIC = 'statistic';
export const SETTINGS = 'settings';
export const PAYROLL = 'payroll';
export const SUPPORT = 'support';
export const HOME = 'home';
export const USER_LEAVE = 'user_leave';
export const PERFORMANCE = 'performance';
export const PROFILE = 'profile';
export const PROBATION = 'probation';
export const TERMINATION = 'termination';
export const CHECKLIST = 'checklist';
export const EMPLOYMENT = 'employment';
export const PERSONAL = 'personal';
export const PERSONAL_DASHBOARD = 'dashboard';
export const TEAM_MANAGEMENT = 'team-management';
export const RECRUITMENT = 'recruitment';
export const MASTER_DATA = 'master-data';
export const PERFORMANCE_APPRAISALS = 'performance-appraisals';
export const HR_ADMINISTRATION = 'hr-administration';
export const LEAVE_HOLIDAYS = 'leave-holidays';
export const SALARY = 'salary';
export const DIRECTORY = 'directory';
export const ORG_CHART = 'org-chart';
export const DOCUMENTS = 'documents';
export const APPROVALS = 'approvals';
export const REQUEST_MANAGEMENT = 'request-management';
export const CADIDATES = 'candidates';
export const INTERVIEWS = 'interviews';
export const EMPLOYEE_MANAGEMENT = 'employee-management';
export const OFFERS = 'offers';
export const ALL_RESIGNATIONS = 'all-resignations';
export const RESIGNATIONS_REQUESTS = 'resignations-requests';
export const WORK_PERMITS = 'work-permits';
export const VISAS = 'visas';
export const ALL_LEAVE_REQUESTS = 'all-leave-requests';
export const LEAVE_REQUESTS = 'leave-requests';
export const STAFF_MOVEMENT = 'staff-movement';
export const POSITION = 'Positions';
export const ALL_CONTRACT = 'all-contracts';
export const ALL_APPENDIXES = 'all-appendixes';
export const REQUEST_NEW_HIRE = 'request-new-hire';
export const PROBATION_ASSESSMENT = 'probation-assessment';
export const CONTRACTS = 'contracts';
export const PERSONAL_DOCUMENTS = 'personal-documents';
export const DOCUMENTS_CONTROL_SYSTEM = 'document-control-system';
export const VISA_WORK_PERMIT = 'Visa-and-work-permit';
export const RESIGNATIONS = 'Resignation';
